export default __webpack_public_path__ + "static/media/two-lines-pattern.0a45d2cf.svg";